import React from 'react';
import { Link } from 'react-router-dom';
import { SproutIcon, FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-soil-brown text-white pt-12 pb-6" data-id="element-268">
      <div className="container mx-auto px-4" data-id="element-269">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8" data-id="element-270">
          <div data-id="element-271">
            <div className="flex items-center mb-4" data-id="element-272">
              <div className="bg-white rounded-full p-1 mr-2" data-id="element-273">
                <SproutIcon size={24} className="text-leaf-green" data-id="element-274" />
              </div>
              <span className="text-xl font-montserrat font-bold" data-id="element-275">
                GrowConnect
              </span>
            </div>
            <p className="text-gray-300 mb-4" data-id="element-276">
              Connecting farmers, investors, and agricultural projects for a
              sustainable future.
            </p>
            <div className="flex space-x-4" data-id="element-277">
              <a href="#" className="text-white hover:text-leaf-green" aria-label="Facebook" data-id="element-278">
                <FacebookIcon size={20} data-id="element-279" />
              </a>
              <a href="#" className="text-white hover:text-leaf-green" aria-label="Twitter" data-id="element-280">
                <TwitterIcon size={20} data-id="element-281" />
              </a>
              <a href="#" className="text-white hover:text-leaf-green" aria-label="Instagram" data-id="element-282">
                <InstagramIcon size={20} data-id="element-283" />
              </a>
              <a href="#" className="text-white hover:text-leaf-green" aria-label="LinkedIn" data-id="element-284">
                <LinkedinIcon size={20} data-id="element-285" />
              </a>
            </div>
          </div>
          <div data-id="element-286">
            <h3 className="text-lg font-semibold mb-4" data-id="element-287">Quick Links</h3>
            <ul className="space-y-2" data-id="element-288">
              <li data-id="element-289">
                <Link to="/" className="text-gray-300 hover:text-white" data-id="element-290">
                  Home
                </Link>
              </li>
              <li data-id="element-291">
                <Link to="/projects" className="text-gray-300 hover:text-white" data-id="element-292">
                  Projects
                </Link>
              </li>
              <li data-id="element-293">
                <Link to="/discover" className="text-gray-300 hover:text-white" data-id="element-294">
                  Discover
                </Link>
              </li>
              <li data-id="element-295">
                <Link to="/deals" className="text-gray-300 hover:text-white" data-id="element-296">
                  Deals
                </Link>
              </li>
              <li data-id="element-297">
                <Link to="/progress" className="text-gray-300 hover:text-white" data-id="element-298">
                  Progress
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-299">
            <h3 className="text-lg font-semibold mb-4" data-id="element-300">Resources</h3>
            <ul className="space-y-2" data-id="element-301">
              <li data-id="element-302">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-303">
                  Help Center
                </a>
              </li>
              <li data-id="element-304">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-305">
                  Knowledge Base
                </a>
              </li>
              <li data-id="element-306">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-307">
                  Community
                </a>
              </li>
              <li data-id="element-308">
                <a href="#" className="text-gray-300 hover:text-white" data-id="element-309">
                  Blog
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-310">
            <h3 className="text-lg font-semibold mb-4" data-id="element-311">Contact</h3>
            <ul className="space-y-2" data-id="element-312">
              <li className="text-gray-300" data-id="element-313">support@growconnect.com</li>
              <li className="text-gray-300" data-id="element-314">+1 (555) 123-4567</li>
              <li className="text-gray-300" data-id="element-315">123 Farm Road, Agriville</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 mt-6 text-center text-gray-400 text-sm" data-id="element-316">
          <p data-id="element-317">
            &copy; {new Date().getFullYear()} GrowConnect. All rights reserved.
          </p>
          <div className="mt-2 flex justify-center space-x-4" data-id="element-318">
            <a href="#" className="hover:text-white" data-id="element-319">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white" data-id="element-320">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white" data-id="element-321">
              Accessibility
            </a>
          </div>
        </div>
      </div>
    </footer>;
};